// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Canvas 样式 */
.Canvas-wrapper {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.Canvas-reactflow {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
}

/* React Flow 节点默认样式覆盖 */
.react-flow__node {
  cursor: grab;
}

.react-flow__node.selected {
  box-shadow: 0 0 0 1px #667eea;
  border-radius: 12px;
}

.react-flow__handle {
  width: 12px;
  height: 12px;
  background: #667eea;
  border: 2px solid white;
}

.react-flow__edge-path {
  stroke: #667eea;
  stroke-width: 2;
}

.react-flow__edge.selected .react-flow__edge-path {
  stroke: #3b82f6;
  stroke-width: 3;
}

/* 保存状态指示器 */
.Canvas-save-indicator {
  position: absolute;
  top: 16px;
  right: 80px;
  z-index: 10;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  animation: Canvas-save-indicator-fade-in 0.2s ease-out;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

@keyframes Canvas-save-indicator-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.Canvas-save-indicator-saving {
  background: #fff3e0;
  color: #e65100;
  border: 1px solid #ffb74d;
}

.Canvas-save-indicator-saved {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #66bb6a;
}

/* 保存中的旋转动画 */
.Canvas-save-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid #e65100;
  border-top-color: transparent;
  border-radius: 50%;
  animation: Canvas-save-spinner-spin 0.8s linear infinite;
}

@keyframes Canvas-save-spinner-spin {
  to {
    transform: rotate(360deg);
  }
}

/* 已保存的对勾 */
.Canvas-save-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 14px;
  font-weight: bold;
  color: #2e7d32;
}

/* 隐藏 React Flow 的品牌标识（保留缩略图） */
.react-flow__attribution {
  display: none !important;
}

/* 模式切换按钮 */
.Canvas-mode-toggle {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  gap: 2px;
  background: white;
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.Canvas-mode-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #666;
  transition: all 0.2s ease;
  user-select: none;
}

.Canvas-mode-button:hover {
  background: #f5f5f5;
  color: #333;
}

.Canvas-mode-button-active {
  background: #667eea !important;
  color: white !important;
}

.Canvas-mode-button-active:hover {
  background: #5568d3 !important;
}

.Canvas-mode-icon {
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Canvas-mode-icon-flip {
  transform: scaleX(-1);
}

.Canvas-mode-label {
  font-size: 13px;
  font-weight: 500;
}

/* 选择框样式 */
.react-flow__selection {
  background: rgba(102, 126, 234, 0.1);
  border: 2px solid #667eea;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/Canvas.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sDAAsD;EACtD,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":["/* Canvas 样式 */\n.Canvas-wrapper {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n}\n\n.Canvas-reactflow {\n  background: #f5f5f5;\n  width: 100%;\n  height: 100%;\n}\n\n/* React Flow 节点默认样式覆盖 */\n.react-flow__node {\n  cursor: grab;\n}\n\n.react-flow__node.selected {\n  box-shadow: 0 0 0 1px #667eea;\n  border-radius: 12px;\n}\n\n.react-flow__handle {\n  width: 12px;\n  height: 12px;\n  background: #667eea;\n  border: 2px solid white;\n}\n\n.react-flow__edge-path {\n  stroke: #667eea;\n  stroke-width: 2;\n}\n\n.react-flow__edge.selected .react-flow__edge-path {\n  stroke: #3b82f6;\n  stroke-width: 3;\n}\n\n/* 保存状态指示器 */\n.Canvas-save-indicator {\n  position: absolute;\n  top: 16px;\n  right: 80px;\n  z-index: 10;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  animation: Canvas-save-indicator-fade-in 0.2s ease-out;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n@keyframes Canvas-save-indicator-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.Canvas-save-indicator-saving {\n  background: #fff3e0;\n  color: #e65100;\n  border: 1px solid #ffb74d;\n}\n\n.Canvas-save-indicator-saved {\n  background: #e8f5e9;\n  color: #2e7d32;\n  border: 1px solid #66bb6a;\n}\n\n/* 保存中的旋转动画 */\n.Canvas-save-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid #e65100;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: Canvas-save-spinner-spin 0.8s linear infinite;\n}\n\n@keyframes Canvas-save-spinner-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* 已保存的对勾 */\n.Canvas-save-check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #2e7d32;\n}\n\n/* 隐藏 React Flow 的品牌标识（保留缩略图） */\n.react-flow__attribution {\n  display: none !important;\n}\n\n/* 模式切换按钮 */\n.Canvas-mode-toggle {\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  display: flex;\n  gap: 2px;\n  background: white;\n  border-radius: 8px;\n  padding: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e0e0e0;\n}\n\n.Canvas-mode-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  color: #666;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.Canvas-mode-button:hover {\n  background: #f5f5f5;\n  color: #333;\n}\n\n.Canvas-mode-button-active {\n  background: #667eea !important;\n  color: white !important;\n}\n\n.Canvas-mode-button-active:hover {\n  background: #5568d3 !important;\n}\n\n.Canvas-mode-icon {\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.Canvas-mode-icon-flip {\n  transform: scaleX(-1);\n}\n\n.Canvas-mode-label {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* 选择框样式 */\n.react-flow__selection {\n  background: rgba(102, 126, 234, 0.1);\n  border: 2px solid #667eea;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
